import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading, generateYearRange,isNumeric, validateButtonASIBlock,getStatusFlagValue} from '../../Custom/Custom';
import titlesData from '../../titles.json';
import asiTitle from '../../asi.json';
import BlockHJsonData from '../../assets/BlockHData.json';
import BlockIData from '../../assets/BlockIData.json';
import BlockJData from '../../assets/BlockJData.json';

export default function BlockC({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

  const [itemData, setItemData] = useState({});
  const [blockCData, setBlockCData] = useState({});
  const navigate = useNavigate();
  const yearRange=generateYearRange(blockInfo.surveyYear);
  const [buttonStatus,setButtonStatus]=useState('');
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split('|')
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isDivasiRole = roleCodes.includes('DIVASI');
  const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
  const currentStatusFlag = Array.isArray(blockCData) && blockCData.length > 0 ? blockCData[0]?.statusFlag : '';
  const isDivasiStatusFlagOne = isDivasiRole && String(currentStatusFlag ?? '').trim() === '1';
  const isHqStatusFlagThree = isHqRole && String(currentStatusFlag ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(currentStatusFlag ?? '').trim() === '';
  const statusUnitCode=localStorage.getItem('statusUnitCode')
  const nextBlockId = statusUnitCode === '2' ? 5 : (statusUnitCode === '3' ? 12 : 4);
  const nextBlockRoute = statusUnitCode === '2' ? "/BlockE" : (statusUnitCode === '3' ? "/BlockL" : "/BlockD");
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(nextBlockId);
  })();
  
  let srNo=0;
  let statusAlertC=0;
  let allValidactionAlertBlockC='';
  let flagC = 0;
  const storedLanguage = localStorage.getItem('language');

 
  


  useEffect(()=>{

    // Function to handle page load Form data
     const blockBData= async()=>{
     const newObject={
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear
      };
      showAppLoading(true)
      try {
        const response = await axios.post(`${API_URL}api/asi/blockCForm`, newObject, config);
      //   const response = await axios.post(`https://updesdev.srmtechsol.com/api/asi/blockCForm`, newObject, config);
        const {data,status} = response.data;
           if (status) {
              const blockCData=data.blockCData;
              setBlockCData(blockCData)
               const statusFlage = blockCData[0].statusFlag;
               const buttonStatus = await validateButtonASIBlock(decode_token, statusFlage);
               setButtonStatus(buttonStatus);

              const initialData = {};
   
              blockCData.forEach(item => {
                   initialData[item.assetCode] = {
                    dslNo: item.dslNo,
                    surveyYear: item.surveyYear,
                    assetCode: item.assetCode,
                    dueToRevaluation: item.dueToRevaluation,
                    actualAdditions: item.actualAdditions,
                    deductionAdjDuringYear: item.deductionAdjDuringYear,
                    closingAsOn3456: item.closingAsOn3456,
                    uptoYearBeginning: item.uptoYearBeginning,
                    providedDuringYear: item.providedDuringYear,
                    adjForSoldDiscardedDuringYear: item.adjForSoldDiscardedDuringYear,
                    uptoYearEnd: item.uptoYearEnd,
                    openingAsOn38:item.openingAsOn38,
                    openingAsOn: item.openingAsOn,
                    closingAsOn711: item.closingAsOn711,
                    statusFlag:item.statusFlag,
                    closingAsOn3456Class:'textBox_back_color_white',
                    uptoYearEndClass:'textBox_back_color_white',
                    openingAsOn38Class:'textBox_back_color_white',
                    closingAsOn711Class:'textBox_back_color_white',
                    providedDuringYearClass: 'textBox_back_color_white',
                    openingAsOnClass:'textBox_back_color_white',
                    dueToRevaluationClass:'textBox_back_color_white',
                    actualAdditionsClass:'textBox_back_color_white',
                    deductionAdjDuringYearClass:'textBox_back_color_white',
                    adjForSoldDiscardedDuringYearClass:'textBox_back_color_white',
                    uptoYearBeginningClass:'textBox_back_color_white'

                   };
                 });
              
             setItemData(initialData);


          
            }
      } catch (error) {
          console.error(error);
          toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
          showAppLoading(false);
      }
  
    }
    blockBData();
  
    },[])



  // Status 2: Block D ko 0 data ke sath auto-save karke Block E tak navigate
  const saveBlockDWithZeroData = async () => {
    try {
      const formRes = await axios.post(`${API_URL}api/asi/blockDForm`, {
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear
      }, config);
      const blockDData = formRes.data?.data?.blockDData || formRes.data?.blockDData || [];
      const clickButtonStatusFlag = getStatusFlagValue("SAVE", userInfoObject?.userLevel);
      const itemCodes = (blockDData.length > 0)
        ? blockDData.map((item) => ({
            dslNo: item.dslNo ?? blockInfo.dslNo,
            surveyYear: item.surveyYear ?? blockInfo.surveyYear,
            itemCode: item.itemCode,
            statusFlag: clickButtonStatusFlag,
            openingAmount: 0,
            closingAmount: 0
          }))
        : [];
      const newObject = {
        itemCodes,
        payload: {
          dsl_no: blockInfo.dslNo,
          survey_year: blockInfo.surveyYear,
          buttonType: "SAVE"
        }
      };
      await axios.post(`${API_URL}api/asi/blockDFormSaveToDB`, newObject, config);
      return true;
    } catch (err) {
      console.error('[BlockC] Block D 0-save error:', err);
      return false;
    }
  };

  // Status 3: Block C se Block L jump karte time beech ke blocks ko 0-data se auto-save
  const autoSaveIntermediateBlocksWithZeroDataStatus3 = async () => {
    const clickButtonStatusFlag = getStatusFlagValue("SAVE", userInfoObject?.userLevel);
    const payload = { dsl_no: blockInfo.dslNo, survey_year: blockInfo.surveyYear };
    const savePayload = { ...payload, buttonType: "SAVE" };
    const getData = (res) => res?.data?.data ?? res?.data ?? {};

    const safePost = async (url, body) => {
      try {
        await axios.post(url, body, config);
        return true;
      } catch (e) {
        console.error(`[BlockC] auto-save failed: ${url}`, e);
        return false;
      }
    };

    // Block D
    await saveBlockDWithZeroData();

    // Block E
    try {
      const res = await axios.post(`${API_URL}api/asi/blockEForm`, payload, config);
      const data = getData(res);
      const rows = data.blockEData || [];
      const itemCodes = rows.map((r) => ({
        dslNo: r.dslNo ?? blockInfo.dslNo,
        surveyYear: r.surveyYear ?? blockInfo.surveyYear,
        catagoryId: r.catagoryId,
        manufacturing: 0,
        nonmanufacturing: 0,
        total: 0,
        avgNoPersonsWorked: 0,
        noMandaysPaid: 0,
        wagesOrSalaries: 0,
        statusFlag: clickButtonStatusFlag
      }));
      await safePost(`${API_URL}api/asi/blockEFormSaveDB`, { itemCodes, payload: savePayload });
    } catch (e) {
      console.error('[BlockC] auto-save BlockE error', e);
    }

    // Block F
    try {
      const res = await axios.post(`${API_URL}api/asi/blockFForm`, payload, config);
      const data = getData(res);
      const rows = data.blockFData || [];
      const itemCodes = rows.map((r) => ({
        dslNo: r.dslNo ?? blockInfo.dslNo,
        surveyYear: r.surveyYear ?? blockInfo.surveyYear,
        itemCode: r.itemCode,
        expenditure: 0,
        statusFlag: clickButtonStatusFlag
      }));
      await safePost(`${API_URL}api/asi/blockFFormSaveToDB`, { itemCodes, payload: savePayload });
    } catch (e) {
      console.error('[BlockC] auto-save BlockF error', e);
    }

    // Block G (needs itemCodes)
    try {
      const res = await axios.post(`${API_URL}api/asi/blockGForm`, payload, config);
      const data = getData(res);
      const rows = data.blockGData || [];
      const itemCodes = rows.map((r) => ({
        dslNo: r.dslNo ?? blockInfo.dslNo,
        surveyYear: r.surveyYear ?? blockInfo.surveyYear,
        itemCode: r.itemCode,
        recipts: 0,
        statusFlag: clickButtonStatusFlag
      }));
      await safePost(`${API_URL}api/asi/blockGFormSaveToDB`, { itemCodes, payload: savePayload });
    } catch (e) {
      console.error('[BlockC] auto-save BlockG error', e);
    }

    // Block H/I/J from static JSONs (same payload structure as normal saves)
    await safePost(`${API_URL}api/asi/blockHFormSaveToDB`, {
      itemCodes: (Array.isArray(BlockHJsonData) ? BlockHJsonData : []).map((r, idx) => ({
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        srno: 0,
        itemCode: r.itemCode ?? '',
        itemDesc: r.itemDesc ?? '',
        unitOfQty: r.unitOfQty ?? '',
        qtyConsumed: 0,
        purchaseValue: 0,
        ratePerUnit: 0,
        saveOrderBy: idx + 1,
        statusFlag: clickButtonStatusFlag
      })),
      payload: savePayload
    });

    await safePost(`${API_URL}api/asi/blockIFormSaveToDB`, {
      itemCodes: (Array.isArray(BlockIData) ? BlockIData : []).map((r) => ({
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemCode: r.itemCode ?? '',
        itemDesc: r.itemDesc ?? '',
        purchaseValue: 0,
        qtyConsumed: 0,
        ratePerUnit: 0,
        unitOfQty: r.unitOfQty ?? '',
        statusFlag: clickButtonStatusFlag
      })),
      payload: savePayload
    });

    await safePost(`${API_URL}api/asi/blockJFormSaveToDB`, {
      itemCodes: (Array.isArray(BlockJData) ? BlockJData : []).map((r) => ({
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemCode: r.itemCode ?? '',
        itemDesc: r.itemDesc ?? '',
        unitOfQty: r.unitOfQty ?? '',
        qtyManufactured: 0,
        qtySold: 0,
        grossSaleValue: 0,
        perunitNetsaleValue: 0,
        exfactoryValueQty: 0,
        distributiveExpensesExciseDuty: 0,
        distributiveExpensesSalesTaxVat: 0,
        distributiveExpensesOthers: 0,
        distributiveExpensesTotal: 0,
        statusFlag: clickButtonStatusFlag
      })),
      payload: savePayload
    });

    // Block K (needs ictIndicatorCode list)
    try {
      const res = await axios.post(`${API_URL}api/asi/blockKForm`, payload, config);
      const data = getData(res);
      const rows = data.blockKData || [];
      const itemCodes = rows.map((r) => ({
        dslNo: r.dslNo ?? blockInfo.dslNo,
        surveyYear: r.surveyYear ?? blockInfo.surveyYear,
        code: '',
        ictIndicatorCode: r.ictIndicatorCode,
        ItemsName: r.ItemsName,
        statusFlag: clickButtonStatusFlag
      }));
      await safePost(`${API_URL}api/asi/blockKFormSaveToDB`, { itemCodes, payload: savePayload });
    } catch (e) {
      console.error('[BlockC] auto-save BlockK error', e);
    }
  };

  // Function to handle going to the next block  
  const handleNext= async()=>{
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
        navigate(nextBlockRoute);
        return;
      }
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
        if (statusUnitCode === '2') {
          navigate("/BlockE");
        } else if (statusUnitCode === '3') {
          navigate("/BlockL");
        } else {
          navigate("/BlockD");
        }
        return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
        if (statusUnitCode === '2') {
          navigate("/BlockE");
        } else if (statusUnitCode === '3') {
          navigate("/BlockL");
        } else {
          navigate("/BlockD");
        }
        return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;
      if(statusUnitCode==='5'){
            const saveResult = await handleSaveData("SAVE");
            if(saveResult){
               await blockValidation()
               navigate("/BlockD")
            }
     
      }else{
         const saveResult = await handleSaveData("SAVE");
         if (saveResult) {
            if (statusUnitCode === '2') {
              await saveBlockDWithZeroData();
            }
            if (statusUnitCode === '3') {
              await autoSaveIntermediateBlocksWithZeroDataStatus3();
            }
            await blockValidation()
            if (statusUnitCode === '2') {
              navigate("/BlockE")
            } else if (statusUnitCode === '3') {
              navigate("/BlockL")
            } else {
              navigate("/BlockD")
            }
        }
      }
}



  //All block validation Data
  const  blockValidation=async()=>{

   let  postData= {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
     }
 
  try {
     showAppLoading(true);
      const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
      const {data,status} = response.data;
      const accessIds=data.allblockData
       if(accessIds.length>0){
         if (statusUnitCode === '2') {
           // status=2 sequence should unlock E (id 5) after C
           accessAsiBlock([1,2,3,5])
         } else if (statusUnitCode === '3') {
           // status=3 jump should unlock L (id 12) after C
           accessAsiBlock([1,2,3,12])
         } else if(accessIds.length > [1,2,3,4].length){
           accessAsiBlock(accessIds)
         } else {
           accessAsiBlock([1,2,3,4])
         }
       } else {
         if (statusUnitCode === '2') {
           accessAsiBlock([1,2,3,5])
         } else if (statusUnitCode === '3') {
           accessAsiBlock([1,2,3,12])
         } else {
           accessAsiBlock([1,2,3,4])
         }
       }
       showAppLoading(false);
        return true;
 
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
     } finally {
     
    }
 
 }




// Function to handle going to the previous block
const handlePrevious=()=>{
 const confirmed = window.confirm("Have you saved your changes?");
 if (confirmed) {
   // handleSaveData("SAVE")
   navigate("/BlockB")
 }
 
}


// Function to handle reset Form Data
const handleReset=()=>{
  const initialData = {};
  blockCData.forEach(item => {
	   initialData[item.assetCode] = {
     dslNo: item.dslNo,
     surveyYear: item.surveyYear,
     assetCode: item.assetCode,
     statusFlag:item.statusFlag,
	  controlled_price: '',
     dueToRevaluation: '',
     actualAdditions: '',
     deductionAdjDuringYear: '',
     closingAsOn3456: '',
     uptoYearBeginning: '',
     providedDuringYear: '',
     adjForSoldDiscardedDuringYear: '',
     uptoYearEnd: '',
     openingAsOn38:'',
     openingAsOn: '',
     closingAsOn711: '',
     closingAsOn3456Class:'textBox_back_color_white',
     uptoYearEndClass:'textBox_back_color_white',
     openingAsOn38Class:'textBox_back_color_white',
     closingAsOn711Class:'textBox_back_color_white',
     providedDuringYearClass:'textBox_back_color_white',
     openingAsOnClass:'textBox_back_color_white',
     dueToRevaluationClass:'textBox_back_color_white',
     actualAdditionsClass:'textBox_back_color_white',
     deductionAdjDuringYearClass:'textBox_back_color_white',
     adjForSoldDiscardedDuringYearClass:'textBox_back_color_white',
     uptoYearBeginningClass:'textBox_back_color_white'
   };
	 });
  
 setItemData(initialData);
}



  // Function to handle State on change
const handleOnChange = (assetCode, field, newValue) => {  
    // Allow negative values for specific fields
    const allowNegativeFields = [
      'closingAsOn3456', // column 7
      'uptoYearEnd',     // column 11
      'openingAsOn38',   // column 12
      'closingAsOn711'   // column 13
    ];

    // Custom numeric validation: allow negative for specific fields
    const isAllowedField = allowNegativeFields.includes(field);
    const isValid = isAllowedField
      ? /^-?\d*(\.\d*)?$/.test(newValue) // allow negative and decimal
      : isNumeric(newValue);

    if (!isValid && newValue !== "") {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [assetCode]: {
          ...prevItemData[assetCode],
          [field]: newValue
        }
      };

      return updatedItemData;
    });
}


// Function to handle update and save form data
const handleSaveData = async(buttonType) => {
   // status 5 / status 2: allow save with 0 data (like 4,5,7,8 flow)
   if (statusUnitCode !== '5' && statusUnitCode !== '2' && statusUnitCode !== '3' && !valForBlockC()) {
      return false;
  };
   //return false;   
    let customItemCodes=[];
    const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
    for (let assetCode in itemData) {
      const customObject = {
         dslNo: itemData[assetCode].dslNo,
         surveyYear: itemData[assetCode].surveyYear,
         assetCode: itemData[assetCode].assetCode,
         openingAsOn: handleValue(itemData[assetCode].openingAsOn),
         dueToRevaluation: handleValue(itemData[assetCode].dueToRevaluation),
         actualAdditions: handleValue(itemData[assetCode].actualAdditions),
         deductionAdjDuringYear: handleValue(itemData[assetCode].deductionAdjDuringYear),
         closingAsOn3456: handleValue(itemData[assetCode].closingAsOn3456),
         uptoYearBeginning: handleValue(itemData[assetCode].uptoYearBeginning),
         providedDuringYear: handleValue(itemData[assetCode].providedDuringYear),
         adjForSoldDiscardedDuringYear: handleValue(itemData[assetCode].adjForSoldDiscardedDuringYear),
         uptoYearEnd: handleValue(itemData[assetCode].uptoYearEnd),
         openingAsOn38: handleValue(itemData[assetCode].openingAsOn38),
         closingAsOn711: handleValue(itemData[assetCode].closingAsOn711),
         statusFlag:clickButtonStatusFlag
    
         
      };

      customItemCodes.push(customObject); 
    }
   
   
     const newObject={
          itemCodes:customItemCodes,
          payload:{
             dsl_no: blockInfo.dslNo,
             survey_year:  blockInfo.surveyYear,
             buttonType:buttonType
          }
        }
        showAppLoading(true);
       
        try {
         const response = await axios.post(`${API_URL}api/asi/blockCFormSaveToDB`, newObject, config);
         const {status,message} = response.data;
         if (status) {
            blockValidation();
           toast.success(message, messages.COLOR_RED);
           return true;
         }
       } catch (error) {
           console.error(error);
           toast.error('An error occurred while processing your request.', messages.COLOR_RED);
       } finally {
           showAppLoading(false);
       }
      return false;
   }


   // Function to handle if value empty or null or undefined the set 0
 const handleValue = (value) => {
      return (value !== "" && value !== null && value !== undefined) ? value : 0;
    };
    

   // Function to handle set (Update State) form validation and calculation 
   const handleValidationAlert = (blockCData) => { 
      const initialData = {};
      blockCData.forEach(item => {
           initialData[item.assetCode] = {
            dslNo: item.dslNo,
            surveyYear: item.surveyYear,
            assetCode: item.assetCode,
            dueToRevaluation: item.dueToRevaluation,
            actualAdditions: item.actualAdditions,
            deductionAdjDuringYear: item.deductionAdjDuringYear,
            closingAsOn3456: item.closingAsOn3456,
            uptoYearBeginning: item.uptoYearBeginning,
            providedDuringYear: item.providedDuringYear,
            adjForSoldDiscardedDuringYear: item.adjForSoldDiscardedDuringYear,
            uptoYearEnd: item.uptoYearEnd,
            openingAsOn38:item.openingAsOn38,
            openingAsOn: item.openingAsOn,
            closingAsOn711: item.closingAsOn711,
            statusFlag:item.statusFlag,
            closingAsOn3456Class:item.closingAsOn3456Class,
            uptoYearEndClass:item.uptoYearEndClass,
            openingAsOn38Class:item.openingAsOn38Class,
            closingAsOn711Class:item.closingAsOn711Class,
            providedDuringYearClass:item.providedDuringYearClass,
            openingAsOnClass:item.openingAsOnClass,
            dueToRevaluationClass:item.dueToRevaluationClass,
            actualAdditionsClass:item.actualAdditionsClass,
            deductionAdjDuringYearClass:item.deductionAdjDuringYearClass,
            adjForSoldDiscardedDuringYearClass:item.adjForSoldDiscardedDuringYearClass,
            uptoYearBeginningClass:item.uptoYearBeginningClass
           };
         });
      
     setItemData(initialData);
   }
   
// Function to handle calculation 
const valForBlockC=()=>{

   const yearArray = [2017,2018,2019,2020,2021];
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const customItemCodes = [];
   const openingAsOnObject=[];
   const dueToRevaluationObject=[];
   const actualAdditionsObject=[];
   const deductionAdjDuringYearObject=[];
   const uptoYearBeginningObject=[];
   const providedDuringYearObject=[];
   const adjForSoldDiscardedDuringYearObject=[];
   
      for (let assetCodeId in itemData) {


             let openingAsOn = itemData[assetCodeId].openingAsOn;
             let dueToRevaluation = itemData[assetCodeId].dueToRevaluation;
             let actualAdditions = itemData[assetCodeId].actualAdditions;
             let deductionAdjDuringYear = itemData[assetCodeId].deductionAdjDuringYear;

             let closingAsOn3456 = itemData[assetCodeId].closingAsOn3456;
             let uptoYearBeginning = itemData[assetCodeId].uptoYearBeginning;
             let providedDuringYear = itemData[assetCodeId].providedDuringYear;

             let adjForSoldDiscardedDuringYear = itemData[assetCodeId].adjForSoldDiscardedDuringYear;
             let uptoYearEnd = itemData[assetCodeId].uptoYearEnd;
             let openingAsOn38 = itemData[assetCodeId].openingAsOn38;
             let closingAsOn711 = itemData[assetCodeId].closingAsOn711;
          

             let dslNo = itemData[assetCodeId].dslNo;
             let surveyYear = itemData[assetCodeId].surveyYear;
             let statusFlag = itemData[assetCodeId].statusFlag;
             let assetCode = itemData[assetCodeId].assetCode



            //   class
             let closingAsOn3456Class = itemData[assetCodeId].closingAsOn3456Class;
             let uptoYearEndClass = itemData[assetCodeId].uptoYearEndClass;
             let openingAsOn38Class = itemData[assetCodeId].openingAsOn38Class;
             let closingAsOn711Class = itemData[assetCodeId].closingAsOn711Class;
             let providedDuringYearClass = itemData[assetCodeId].providedDuringYearClass
             let openingAsOnClass = itemData[assetCodeId].openingAsOnClass
             
            if (openingAsOn === '' || openingAsOn === 'null') {
               openingAsOn = 0;
           }
           if (dueToRevaluation === '' || dueToRevaluation === 'null') {
               dueToRevaluation = 0;
           }
          if (actualAdditions === '' || actualAdditions === 'null') {
             actualAdditions = 0;
          }
          if (deductionAdjDuringYear === '' || deductionAdjDuringYear === 'null') {
             deductionAdjDuringYear = 0;
          }
    
    
          if (closingAsOn3456 === '' || closingAsOn3456 === 'null') {
             closingAsOn3456 = 0;
          }
          if (uptoYearBeginning === '' || uptoYearBeginning === 'null') {
             uptoYearBeginning = 0;
          }
          if (providedDuringYear === '' || providedDuringYear === 'null') {
             providedDuringYear = 0;
          }
    
    
          if (adjForSoldDiscardedDuringYear === '' || adjForSoldDiscardedDuringYear === 'null') {
             adjForSoldDiscardedDuringYear = 0;
          }
          if (uptoYearEnd === '' || uptoYearEnd === 'null') {
             uptoYearEnd = 0;
          }
          if (openingAsOn38 === '' || openingAsOn38 === 'null') {
             openingAsOn38 = 0;
          }
          if (closingAsOn711 === '' || closingAsOn711 === 'null') {
             closingAsOn711 = 0;
          }

           //************************************************** */
         if(yearArray.includes(blockInfo.surveyYear)){
            

            // #1  (3 || 4 || 5 || 6)
            if(openingAsOn !== null || dueToRevaluation !== null || 
               actualAdditions !== null || deductionAdjDuringYear !== null){
                  const a3 = parseFloat(openingAsOn); //3
                  const b4 = parseFloat(dueToRevaluation); //4
                  const c5 = parseFloat(actualAdditions); //5
                  const d6 = parseFloat(deductionAdjDuringYear); //6
                  const e7 = parseFloat(closingAsOn3456); //7
                  const f345_6 = a3 + b4 + c5 - d6; 
                  if (e7 !== f345_6) {
                     closingAsOn3456Class="textBox_back_color_red";
                      flagC = 1;
                  } else {
                     closingAsOn3456Class="textBox_back_color_white";
                  }

               }

            // #2  ( 8 || 9 || 10)
               if(uptoYearBeginning !== null || providedDuringYear !== null || 
                  adjForSoldDiscardedDuringYear !== null ){
                  

                     const a5 = parseFloat(actualAdditions);//5
                     const b8 = parseFloat(uptoYearBeginning);//8
                     const c9 = parseFloat(providedDuringYear);//9
                     const d10 = parseFloat(adjForSoldDiscardedDuringYear);//10
                     const e11 = parseFloat(uptoYearEnd);//11
                     const f12 = parseFloat(openingAsOn38);//12
                     const g512 = a5 + f12;  //5+12
                     
                     if (c9 <= (40 * parseFloat(g512)) / 100) {
                        providedDuringYearClass="textBox_back_color_white";

                  } else {
                        providedDuringYearClass="textBox_back_color_orange";
                           if(allValidactionAlertBlockC.indexOf("Col. 9 < =  40% of (col. 5 + col. 12)")<0){
                              allValidactionAlertBlockC = allValidactionAlertBlockC + " Col. 9 < =  40% of (col. 5 + col. 12). \n";
                           }  
                           statusAlertC=1;                                      
                     }

                  
                     const h89_10 = b8 + c9 - d10; //8+9-10
                     if (e11 !== h89_10) {
                        uptoYearEndClass="textBox_back_color_red";
                        flagC = 1;
                  } else {
                     uptoYearEndClass="textBox_back_color_white";
                  }


               }

            //#3 (3 || 8)
               if(openingAsOn !== null || uptoYearBeginning !== null){
                  const a3 = parseFloat(openingAsOn); //3
                  const b8 = parseFloat(uptoYearBeginning);//8
                  const c12 = parseFloat(openingAsOn38);//12
                  const d13 = parseFloat(closingAsOn711);//13
                  const e3_8 = a3 - b8; //3-8
               if (c12 !== e3_8) {
                     openingAsOn38Class="textBox_back_color_red";
                     flagC = 1;

               } else {
               
                     if (c12 > 0 && d13 > 0)
                     {
                        const f1213 = parseFloat(c12 / d13);
                        if (0.2 <= parseFloat(f1213) && parseFloat(f1213) <= 5) {
                              openingAsOn38Class="textBox_back_color_white";

                        } else {
                              openingAsOn38Class = 'textBox_back_color_orange';
                           if(allValidactionAlertBlockC.indexOf("0.2 <= (col.12/col.13) <= 5")<0){
                                 allValidactionAlertBlockC = allValidactionAlertBlockC + " 0.2 <= (col.12/col.13) <= 5, if both col.12 and col.13> 0. \n";
                           }
                           statusAlertC = 1;
                        }
                     }

               }

               }
               
            //#4 (7 || 11)
               if(closingAsOn3456 !==null || uptoYearEnd !==null ){

                  const a7 = parseFloat(closingAsOn3456); //7
                  const b11 = parseFloat(uptoYearEnd);//11
                  const c12 = parseFloat(openingAsOn38);//12
                  const d13 = parseFloat(closingAsOn711);//13
                  const e7_11 = a7 - b11;

                  if (d13 !== e7_11) {
                        closingAsOn711Class="textBox_back_color_red"
                        flagC = 1;

               } else {
                     
                     if (c12 > 0 && d13 > 0)
                     {
                        const f1213 = parseFloat(c12) / parseFloat(d13);
                        if (0.2 <= parseFloat(f1213) && parseFloat(f1213) <= 5) {
                           closingAsOn711Class = "textBox_back_color_white"
                        } else {

                           closingAsOn711Class = "textBox_back_color_orange";

                        }
                     }


               }
               }

        }else{

           //#1  (3 || 4 || 5 || 6)
           if(openingAsOn !== null && dueToRevaluation !== null
             && actualAdditions !== null && deductionAdjDuringYear !== null){

               const a3_3456 = parseFloat(openingAsOn); //3
               const b4_3456 = parseFloat(dueToRevaluation);//4
               const c5_3456 = parseFloat(actualAdditions);//5
               const d6_3456 = parseFloat(deductionAdjDuringYear);//6
               const e7_3456 = parseFloat(closingAsOn3456); //7
               const f345_6_3456 = a3_3456 + b4_3456 + c5_3456 - d6_3456; 

               if (e7_3456 !== f345_6_3456) { //(7) != (3+4+5-6)
                  closingAsOn3456Class="textBox_back_color_red";
               	flagC=1;
                } else {
                  closingAsOn3456Class="textBox_back_color_white";
               }

             }

            //#2 (8 || 9 || 10)
            if(uptoYearBeginning !== null && providedDuringYear !== null && 
               adjForSoldDiscardedDuringYear !== null)
            {
               const a8_8910 = parseFloat(uptoYearBeginning);//8
               const b9_8910 = parseFloat(providedDuringYear);//9
               const c10_8910 = parseFloat(adjForSoldDiscardedDuringYear);//10
               const d11_8910 = parseFloat(uptoYearEnd); //11
               const f89_10 = a8_8910 + b9_8910 - c10_8910;
               if (d11_8910 !== f89_10) {  //(11) !==(8+9-10)
                  uptoYearEndClass="textBox_back_color_red";
                  flagC=1;
               } else {
                  uptoYearEndClass="textBox_back_color_white";
               }
            }
       
            //#3  (3 || 8)
            if(openingAsOn !== null || uptoYearBeginning !== null){
               const a3_38 = parseFloat(openingAsOn); //3
               const b8_38 = parseFloat(uptoYearBeginning);//8
               const c12_38 = parseFloat(openingAsOn38);//12
               const d3_8 = a3_38 - b8_38;
               if(c12_38 !== d3_8 ){    //(12) !== (3-4) 
                  openingAsOn38Class="textBox_back_color_red";
                  flagC=1;
               }else{
                  openingAsOn38Class="textBox_back_color_white";
               }
            }

             //#4 (7 || 11)
             if(closingAsOn3456 !== null || uptoYearEnd !== null){

               const a3_7_11 = parseFloat(openingAsOn); //3
               const b4_7_11 = parseFloat(dueToRevaluation);//4
               const c5_7_11 = parseFloat(actualAdditions);//5
               const d6_7_11 = parseFloat(deductionAdjDuringYear);//6

               const a8_7_11 = parseFloat(uptoYearBeginning);//8
               const b9_7_11 = parseFloat(providedDuringYear);//9
               const c10_7_11 = parseFloat(adjForSoldDiscardedDuringYear);//10



               // const a7 = parseFloat(closingAsOn3456); //7
               // const b11 = parseFloat(uptoYearEnd);//11
               const c13 = parseFloat(closingAsOn711);//13
               //var d7_11 = a7-b11;
               const f3456_7_11 = a3_7_11 + b4_7_11 + c5_7_11 - d6_7_11;  //val7
               const f8910_7_11 = a8_7_11 + b9_7_11 - c10_7_11; //val11
               const d7_11 = f3456_7_11 - f8910_7_11;

            if(c13 !== d7_11){ 
                  closingAsOn711Class="textBox_back_color_red";
                  flagC=1;
               }else{
                  closingAsOn711Class="textBox_back_color_white";
               }
             }
       }
      const customObject = {
               assetCode: assetCode,
               openingAsOn:openingAsOn,
               dueToRevaluation:dueToRevaluation,
               actualAdditions:actualAdditions,
               deductionAdjDuringYear:deductionAdjDuringYear,
               closingAsOn3456:closingAsOn3456,
               uptoYearBeginning:uptoYearBeginning,
               providedDuringYear:providedDuringYear,
               adjForSoldDiscardedDuringYear:adjForSoldDiscardedDuringYear,
               uptoYearEnd:uptoYearEnd,
               openingAsOn38:openingAsOn38,
               closingAsOn711:closingAsOn711,
               dslNo:dslNo,
               surveyYear:surveyYear,
               statusFlag:statusFlag,
               closingAsOn3456Class:closingAsOn3456Class,
               uptoYearEndClass:uptoYearEndClass,
               openingAsOn38Class:openingAsOn38Class,
               closingAsOn711Class:closingAsOn711Class,
               providedDuringYearClass:providedDuringYearClass,
               openingAsOnClass:openingAsOnClass
               
           };
         
           openingAsOnObject.push(parseFloat(openingAsOn))
           dueToRevaluationObject.push(parseFloat(dueToRevaluation))
           actualAdditionsObject.push(parseFloat(actualAdditions))
           deductionAdjDuringYearObject.push(parseFloat(deductionAdjDuringYear))
           uptoYearBeginningObject.push(parseFloat(uptoYearBeginning))
           providedDuringYearObject.push(parseFloat(providedDuringYear))
           adjForSoldDiscardedDuringYearObject.push(parseFloat(adjForSoldDiscardedDuringYear))
           customItemCodes.push(customObject);

      }
      const allRowsObject={
         openingAsOnObject:openingAsOnObject,
         dueToRevaluationObject:dueToRevaluationObject,
         actualAdditionsObject:actualAdditionsObject,
         deductionAdjDuringYearObject:deductionAdjDuringYearObject,
         uptoYearBeginningObject:uptoYearBeginningObject,
         providedDuringYearObject:providedDuringYearObject,
         adjForSoldDiscardedDuringYearObject:adjForSoldDiscardedDuringYearObject,
         customItemCodes:customItemCodes
      }
   return valueInsertedA1(allRowsObject); 
}

const  valueInsertedA1=(allRowsObject)=>{
 
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const openingAsOnObject=allRowsObject.openingAsOnObject;
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      // Items 2-10 means indices 1-9 (0-indexed)
      const openingAsOn10 = openingAsOnObject[10]; // Sub-total row
      const numbers = openingAsOnObject.slice(1, 10).map(item => parseFloat(item)).filter(item => !isNaN(item));
      const openingAsOn1To9 = numbers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      if(openingAsOn10 !== openingAsOn1To9){
         flagC = 1;
         allRowsObject.customItemCodes[10].openingAsOnClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].openingAsOnClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const openingAsOn6 = openingAsOnObject[7];
      const numbers = openingAsOnObject.slice(1, 7).map(item => parseFloat(item)).filter(item => !isNaN(item));
      const openingAsOn1To6 = numbers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
      if(openingAsOn6 !== openingAsOn1To6){
         flagC = 1;
         allRowsObject.customItemCodes[7].openingAsOnClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].openingAsOnClass="textBox_back_color_white";
      }
   }
 
   return valueInsertedB1(allRowsObject);
}


//Opening as on - Total
const valueInsertedB1=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const openingAsOnObject=allRowsObject.openingAsOnObject;
  
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      // Items 11 + 12 means indices 10 + 11 (Sub-total + Capital work in progress)
      const openingAsOn0 = openingAsOnObject[0] //new row
      const openingAsOn10 = openingAsOnObject[10]; // Sub-total (items 2 to 10)
      const openingAsOn11 = openingAsOnObject[11]; // Capital work in progress
      const openingAsOn12test = openingAsOnObject[12]; // Total (items 1+ 11 + 12)
      
      const openingAsOn12ShouldBe = openingAsOn0+ openingAsOn10 + openingAsOn11;
      
      if(openingAsOn12test !== openingAsOn12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].openingAsOnClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].openingAsOnClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const openingAsOn0 = openingAsOnObject[0];
      const openingAsOn7 = openingAsOnObject[7];
      const openingAsOn8 = openingAsOnObject[8];
      const openingAsOn9test = openingAsOnObject[9];

      // Row 10 = Row 1 + Row 8 + Row 9 (index 0 + 7 + 8)
      const openingAsOn10ShouldBe = openingAsOn0 + openingAsOn7 + openingAsOn8;

      if(openingAsOn9test !== openingAsOn10ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[9].openingAsOnClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].openingAsOnClass="textBox_back_color_white";
      }
   }

   return valueInsertedA2(allRowsObject);
}



const valueInsertedA2=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const dueToRevaluationRow=allRowsObject.dueToRevaluationObject;

   console.log("=====dueToRevaluationRow",dueToRevaluationRow);
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      // Items 2-10 means indices 1-9
      const dueToRevaluation10test = dueToRevaluationRow[10];
      const dueToRevaluation1to9 = dueToRevaluationRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
      console.log("=====dueToRevaluation10test",dueToRevaluation10test);
      console.log("=====dueToRevaluation1to9",dueToRevaluation1to9);
      
      if(dueToRevaluation10test !== dueToRevaluation1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].dueToRevaluationClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].dueToRevaluationClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const dueToRevaluation1 = dueToRevaluationRow[1];
      const dueToRevaluation2 = dueToRevaluationRow[2];
      const dueToRevaluation3 = dueToRevaluationRow[3];
      const dueToRevaluation4 = dueToRevaluationRow[4];
      const dueToRevaluation5 = dueToRevaluationRow[5];
      const dueToRevaluation6 = dueToRevaluationRow[6];
      const dueToRevaluation7test = dueToRevaluationRow[7];

      const dueToRevaluation1to6 = (dueToRevaluation1 + dueToRevaluation2 + dueToRevaluation3 + dueToRevaluation4 + dueToRevaluation5 + dueToRevaluation6);
      if(dueToRevaluation7test !== dueToRevaluation1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].dueToRevaluationClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].dueToRevaluationClass="textBox_back_color_white";
      }
   }
   return valueInsertedB2(allRowsObject);
}

//Due to revaluation - Total
const valueInsertedB2=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const dueToRevaluationRow=allRowsObject.dueToRevaluationObject;
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      // Items 11 + 12 means indices 10 + 11
      const dueToRevaluationRow0 = dueToRevaluationRow[0]
      const dueToRevaluation10 = dueToRevaluationRow[10]; // Sub-total
      const dueToRevaluation11 = dueToRevaluationRow[11]; // Capital work in progress
      const dueToRevaluation12Test = dueToRevaluationRow[12]; // Total
      
      const dueToRevaluation12ShouldBe = dueToRevaluationRow0 + dueToRevaluation10 + dueToRevaluation11;
      
      if(dueToRevaluation12Test !== dueToRevaluation12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].dueToRevaluationClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].dueToRevaluationClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const dueToRevaluation0 = dueToRevaluationRow[0];
      const dueToRevaluation8 = dueToRevaluationRow[8];
      const dueToRevaluation9Test = dueToRevaluationRow[9];

      const dueToRevaluation1 = dueToRevaluationRow[1];
      const dueToRevaluation2 = dueToRevaluationRow[2];
      const dueToRevaluation3 = dueToRevaluationRow[3];
      const dueToRevaluation4 = dueToRevaluationRow[4];
      const dueToRevaluation5 = dueToRevaluationRow[5];
      const dueToRevaluation6 = dueToRevaluationRow[6];

      const sum1to6 = dueToRevaluation1 + dueToRevaluation2 + dueToRevaluation3 + dueToRevaluation4 + dueToRevaluation5 + dueToRevaluation6;
      const dueToRevaluation9ShouldBe = dueToRevaluation0 + sum1to6 + dueToRevaluation8;

      if(dueToRevaluation9Test !== dueToRevaluation9ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[9].dueToRevaluationClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].dueToRevaluationClass="textBox_back_color_white";
      }
   }
   return valueInsertedA3(allRowsObject);
}

const valueInsertedA3=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const actualAdditionsRow=allRowsObject.actualAdditionsObject;
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      const actualAdditions10test = actualAdditionsRow[10]; //old code
      const actualAdditions1to9 = actualAdditionsRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0)// new code
      
      if(actualAdditions10test !== actualAdditions1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].actualAdditionsClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].actualAdditionsClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const actualAdditions1 = actualAdditionsRow[1];
      const actualAdditions2 = actualAdditionsRow[2];
      const actualAdditions3 = actualAdditionsRow[3];
      const actualAdditions4 = actualAdditionsRow[4];
      const actualAdditions5 = actualAdditionsRow[5];
      const actualAdditions6 = actualAdditionsRow[6];
      const actualAdditions7test = actualAdditionsRow[7];

      const actualAdditions1to6 = (actualAdditions1 + actualAdditions2 + actualAdditions3 + actualAdditions4 + actualAdditions5 + actualAdditions6);

      if(actualAdditions7test !== actualAdditions1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].actualAdditionsClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].actualAdditionsClass="textBox_back_color_white";
      }
   }
   return valueInsertedB3(allRowsObject);
}


//Actual additions - Total
const valueInsertedB3=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const actualAdditionsRow=allRowsObject.actualAdditionsObject;
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      const actualAdditions0 = actualAdditionsRow[0]
      const actualAdditions10 = actualAdditionsRow[10]; // Sub-total
      const actualAdditions11 = actualAdditionsRow[11]; // Capital work in progress
      const actualAdditions12test = actualAdditionsRow[12]; // Total
      
      const actualAdditions12ShouldBe = actualAdditions0 + actualAdditions10 + actualAdditions11;
      
      if(actualAdditions12test !== actualAdditions12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].actualAdditionsClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].actualAdditionsClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const actualAdditions0 = actualAdditionsRow[0];
      const actualAdditions8 = actualAdditionsRow[8];
      const actualAdditions9test = actualAdditionsRow[9];

      const actualAdditions1 = actualAdditionsRow[1];
      const actualAdditions2 = actualAdditionsRow[2];
      const actualAdditions3 = actualAdditionsRow[3];
      const actualAdditions4 = actualAdditionsRow[4];
      const actualAdditions5 = actualAdditionsRow[5];
      const actualAdditions6 = actualAdditionsRow[6];
      
      const cval = (actualAdditions1 + actualAdditions2 + actualAdditions3 + actualAdditions4 + actualAdditions5 + actualAdditions6);

      const actualAdditions0plus8 = (actualAdditions0 + cval +  actualAdditions8)
      
      if(actualAdditions9test !== actualAdditions0plus8){
         flagC=1;
         allRowsObject.customItemCodes[9].actualAdditionsClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].actualAdditionsClass="textBox_back_color_white";
      }
   }
   return valueInsertedA4(allRowsObject);
}

const valueInsertedA4=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const deductionAdjDuringYearRow=allRowsObject.deductionAdjDuringYearObject;
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      const deductionAdjDuringYear10test = deductionAdjDuringYearRow[10]; //new code
      const deductionAdjDuringYear1to9 = deductionAdjDuringYearRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0); //new code
      
      if(deductionAdjDuringYear10test !== deductionAdjDuringYear1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].deductionAdjDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].deductionAdjDuringYearClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const deductionAdjDuringYear1 = deductionAdjDuringYearRow[1];
      const deductionAdjDuringYear2 = deductionAdjDuringYearRow[2];
      const deductionAdjDuringYear3 = deductionAdjDuringYearRow[3];
      const deductionAdjDuringYear4 = deductionAdjDuringYearRow[4];
      const deductionAdjDuringYear5 = deductionAdjDuringYearRow[5];
      const deductionAdjDuringYear6 = deductionAdjDuringYearRow[6];
      const deductionAdjDuringYear7test = deductionAdjDuringYearRow[7];
      
      const deductionAdjDuringYear1to6 = (deductionAdjDuringYear1 + deductionAdjDuringYear2 + deductionAdjDuringYear3 + deductionAdjDuringYear4 + deductionAdjDuringYear5 + deductionAdjDuringYear6);

      if(deductionAdjDuringYear7test !== deductionAdjDuringYear1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].deductionAdjDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].deductionAdjDuringYearClass="textBox_back_color_white";
      }
   }
   return valueInsertedB4(allRowsObject);
}

//Deduction & adj.during the year
const valueInsertedB4=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const deductionAdjDuringYearRow=allRowsObject.deductionAdjDuringYearObject;
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      const deductionAdjDuringYear0 = deductionAdjDuringYearRow[0]
      const deductionAdjDuringYear10 = deductionAdjDuringYearRow[10]; // Sub-total
      const deductionAdjDuringYear11 = deductionAdjDuringYearRow[11]; // Capital work in progress
      const deductionAdjDuringYear12test = deductionAdjDuringYearRow[12]; // Total
      
      const deductionAdjDuringYear12ShouldBe = deductionAdjDuringYear0 + deductionAdjDuringYear10 + deductionAdjDuringYear11;
      
      if(deductionAdjDuringYear12test !== deductionAdjDuringYear12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].deductionAdjDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].deductionAdjDuringYearClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const deductionAdjDuringYear0 = deductionAdjDuringYearRow[0];
      const deductionAdjDuringYear7 = deductionAdjDuringYearRow[7];
      const deductionAdjDuringYear8 = deductionAdjDuringYearRow[8];
      const deductionAdjDuringYear9test = deductionAdjDuringYearRow[9];
      
      // Row 10 = Row 1 + Row 8 + Row 9 (index 0 + 7 + 8)
      const deductionAdjDuringYear10ShouldBe = deductionAdjDuringYear0 + deductionAdjDuringYear7 + deductionAdjDuringYear8;

      if(deductionAdjDuringYear9test !== deductionAdjDuringYear10ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[9].deductionAdjDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].deductionAdjDuringYearClass="textBox_back_color_white";
      }
   }
   return valueInsertedA5(allRowsObject);
}

const valueInsertedA5=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const uptoYearBeginningRow=allRowsObject.uptoYearBeginningObject;
  
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      const uptoYearBeginning10test = uptoYearBeginningRow[10]; 
      const uptoYearBeginning1to9 = uptoYearBeginningRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0); //new code
      
      if(uptoYearBeginning10test !== uptoYearBeginning1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].uptoYearBeginningClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].uptoYearBeginningClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const uptoYearBeginning1 = uptoYearBeginningRow[1];
      const uptoYearBeginning2 = uptoYearBeginningRow[2];
      const uptoYearBeginning3 = uptoYearBeginningRow[3];
      const uptoYearBeginning4 = uptoYearBeginningRow[4];
      const uptoYearBeginning5 = uptoYearBeginningRow[5];
      const uptoYearBeginning6 = uptoYearBeginningRow[6];
      const uptoYearBeginning7test = uptoYearBeginningRow[7];

      const uptoYearBeginning1to6 = (uptoYearBeginning1 + uptoYearBeginning2 + uptoYearBeginning3 + uptoYearBeginning4 + uptoYearBeginning5 + uptoYearBeginning6);

      if(uptoYearBeginning7test !== uptoYearBeginning1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].uptoYearBeginningClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].uptoYearBeginningClass="textBox_back_color_white";
      }
   }
   return valueInsertedB5(allRowsObject);
}

//Upto year beginning - Total
const valueInsertedB5=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const uptoYearBeginningRow=allRowsObject.uptoYearBeginningObject;
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      const uptoYearBeginning0 = uptoYearBeginningRow[0]
      const uptoYearBeginning10 = uptoYearBeginningRow[10]; // Sub-total
      const uptoYearBeginning11 = uptoYearBeginningRow[11]; // Capital work in progress
      const uptoYearBeginning12test = uptoYearBeginningRow[12]; // Total
      
      const uptoYearBeginning12ShouldBe = uptoYearBeginning0 + uptoYearBeginning10 + uptoYearBeginning11;
      
      if(uptoYearBeginning12test !== uptoYearBeginning12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].uptoYearBeginningClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].uptoYearBeginningClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const uptoYearBeginning0 = uptoYearBeginningRow[0];
      const uptoYearBeginning8 = uptoYearBeginningRow[8];
      const uptoYearBeginning9test = uptoYearBeginningRow[9];

      const uptoYearBeginning1 = uptoYearBeginningRow[1];
      const uptoYearBeginning2 = uptoYearBeginningRow[2];
      const uptoYearBeginning3 = uptoYearBeginningRow[3];
      const uptoYearBeginning4 = uptoYearBeginningRow[4];
      const uptoYearBeginning5 = uptoYearBeginningRow[5];
      const uptoYearBeginning6 = uptoYearBeginningRow[6];

      const fval = (uptoYearBeginning1 + uptoYearBeginning2 + uptoYearBeginning3 + uptoYearBeginning4 + uptoYearBeginning5 + uptoYearBeginning6);
      
      const uptoYearBeginning0to8 = (uptoYearBeginning0 + fval +  uptoYearBeginning8);

      if(uptoYearBeginning9test !== uptoYearBeginning0to8){
         flagC=1;
         allRowsObject.customItemCodes[9].uptoYearBeginningClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].uptoYearBeginningClass="textBox_back_color_white";
      }
   }
   return valueInsertedA6(allRowsObject);
}

const valueInsertedA6=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const providedDuringYearRow=allRowsObject.providedDuringYearObject;
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      const providedDuringYear10test = providedDuringYearRow[10]; //old code
      const providedDuringYear1to9 = providedDuringYearRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0); 
      if(providedDuringYear10test !== providedDuringYear1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].providedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].providedDuringYearClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const providedDuringYear1 = providedDuringYearRow[1];
      const providedDuringYear2 = providedDuringYearRow[2];
      const providedDuringYear3 = providedDuringYearRow[3];
      const providedDuringYear4 = providedDuringYearRow[4];
      const providedDuringYear5 = providedDuringYearRow[5];
      const providedDuringYear6 = providedDuringYearRow[6];
      const providedDuringYear7test = providedDuringYearRow[7];

      const providedDuringYear1to6 = (providedDuringYear1 + providedDuringYear2 + providedDuringYear3 + providedDuringYear4 + providedDuringYear5 + providedDuringYear6);

      if(providedDuringYear7test !== providedDuringYear1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].providedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].providedDuringYearClass="textBox_back_color_white";
      }
   }
   return valueInsertedB6(allRowsObject);
}


//Provided during the year - Total
const valueInsertedB6=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const providedDuringYearRow=allRowsObject.providedDuringYearObject;
   
   if (is2024Year) {
      // For 2024-25: Total (items 11 + 12) is at index 12
      const providedDuringYear0 = providedDuringYearRow[0]
      const providedDuringYear10 = providedDuringYearRow[10]; // Sub-total
      const providedDuringYear11 = providedDuringYearRow[11]; // Capital work in progress
      const providedDuringYear12test = providedDuringYearRow[12]; // Total
      
      const providedDuringYear12ShouldBe =  providedDuringYear0+providedDuringYear10 + providedDuringYear11;
      
      if(providedDuringYear12test !== providedDuringYear12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].providedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].providedDuringYearClass="textBox_back_color_white";
      }
   } else {
      // For old years: Total is at index 9
      const providedDuringYear0 = providedDuringYearRow[0];
      const providedDuringYear8 = providedDuringYearRow[8];
      const providedDuringYear9test = providedDuringYearRow[9];

      const providedDuringYear1 = providedDuringYearRow[1];
      const providedDuringYear2 = providedDuringYearRow[2];
      const providedDuringYear3 = providedDuringYearRow[3];
      const providedDuringYear4 = providedDuringYearRow[4];
      const providedDuringYear5 = providedDuringYearRow[5];
      const providedDuringYear6 = providedDuringYearRow[6];

      const gval = (providedDuringYear1 + providedDuringYear2 + providedDuringYear3 + providedDuringYear4 + providedDuringYear5 + providedDuringYear6);
      
      const providedDuringYear0to8 = (providedDuringYear0 + gval + providedDuringYear8);

      if(providedDuringYear9test !== providedDuringYear0to8){
         flagC=1;
         allRowsObject.customItemCodes[9].providedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[9].providedDuringYearClass="textBox_back_color_white";
      }
   }
   return valueInsertedA7(allRowsObject);
}

const valueInsertedA7=(allRowsObject)=>{
   const is2024Year = blockInfo.surveyYear === 2024 || blockInfo.surveyYear === '2024';
   const adjForSoldDiscardedDuringYearRow=allRowsObject.adjForSoldDiscardedDuringYearObject;
   
   if (is2024Year) {
      // For 2024-25: Sub-total (items 2 to 10) is at index 10
      const adjForSoldDiscardedDuringYear10test = adjForSoldDiscardedDuringYearRow[10]; // Old code ;
      const adjForSoldDiscardedDuringYear1to9 = adjForSoldDiscardedDuringYearRow.slice(1, 10).reduce((sum, val) => sum + (parseFloat(val) || 0), 0); // New code
      
      if(adjForSoldDiscardedDuringYear10test !== adjForSoldDiscardedDuringYear1to9){
         flagC=1;
         allRowsObject.customItemCodes[10].adjForSoldDiscardedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[10].adjForSoldDiscardedDuringYearClass="textBox_back_color_white";
      }
   } else {
      // For old years: Sub-total is at index 7
      const adjForSoldDiscardedDuringYear1 = adjForSoldDiscardedDuringYearRow[1];
      const adjForSoldDiscardedDuringYear2 = adjForSoldDiscardedDuringYearRow[2];
      const adjForSoldDiscardedDuringYear3 = adjForSoldDiscardedDuringYearRow[3];
      const adjForSoldDiscardedDuringYear4 = adjForSoldDiscardedDuringYearRow[4];
      const adjForSoldDiscardedDuringYear5 = adjForSoldDiscardedDuringYearRow[5];
      const adjForSoldDiscardedDuringYear6 = adjForSoldDiscardedDuringYearRow[6];
      const adjForSoldDiscardedDuringYear7test = adjForSoldDiscardedDuringYearRow[7];

      const adjForSoldDiscardedDuringYear1to6 = (adjForSoldDiscardedDuringYear1 + adjForSoldDiscardedDuringYear2 + adjForSoldDiscardedDuringYear3 + adjForSoldDiscardedDuringYear4 + adjForSoldDiscardedDuringYear5 + adjForSoldDiscardedDuringYear6);

      if(adjForSoldDiscardedDuringYear7test !== adjForSoldDiscardedDuringYear1to6){
         flagC=1;
         allRowsObject.customItemCodes[7].adjForSoldDiscardedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[7].adjForSoldDiscardedDuringYearClass="textBox_back_color_white";
      }
   }
   
   // Also need to add Total calculation for adjForSoldDiscardedDuringYear for 2024-25
   if (is2024Year) {
      const adjForSoldDiscardedDuringYear0 = adjForSoldDiscardedDuringYearRow[0]
      const adjForSoldDiscardedDuringYear10 = adjForSoldDiscardedDuringYearRow[10]; // Sub-total
      const adjForSoldDiscardedDuringYear11 = adjForSoldDiscardedDuringYearRow[11]; // Capital work in progress
      const adjForSoldDiscardedDuringYear12test = adjForSoldDiscardedDuringYearRow[12]; // Total
      
      const adjForSoldDiscardedDuringYear12ShouldBe = adjForSoldDiscardedDuringYear0 + adjForSoldDiscardedDuringYear10 + adjForSoldDiscardedDuringYear11;
      
      if(adjForSoldDiscardedDuringYear12test !== adjForSoldDiscardedDuringYear12ShouldBe){
         flagC=1;
         allRowsObject.customItemCodes[12].adjForSoldDiscardedDuringYearClass="textBox_back_color_red";
      } else {
         allRowsObject.customItemCodes[12].adjForSoldDiscardedDuringYearClass="textBox_back_color_white";
      }
   }
   
   handleValidationAlert(allRowsObject.customItemCodes);

   if (statusAlertC === 1) {
     
      allValidactionAlertBlockC = allValidactionAlertBlockC+" \nFor change any Values Click OK."
         let clicked = window.confirm(allValidactionAlertBlockC); 
      
         allValidactionAlertBlockC="";
         statusAlertC = 0;
         if(clicked){
            //valifla = "notnull";
            return false;
         }

   }

   if(flagC===1)
   { 
      //handleValidationAlert(allRowsObject.customItemCodes);
      alert('Total does not match. Please check highlighted fields');
      flagC=0;
      return false;
   }
return true;







}







  return (
    <div className="card-body">
    {/* <ToastContainer/> */}
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_C_TITLE : asiTitle.en.BLOCK_C_TITLE }} />
          </h4>
          <div className="row">
          <div className="col-12 pb-3">
                     <h6 className="fw-semibold">
                     {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span> 
                     {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
                    </h6>
                  </div>
               <div className="col-12">
                  <div className="asi_block_table table-responsive">
                     <table cellPadding="0" cellSpacing="0" id="" className="table table-bordered">
                        <thead>
                           <tr>
                              <th className="text-center" rowSpan="3">{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                              <th className="text-center" rowSpan="3">{storedLanguage === 'hi' ? asiTitle.hi.TYPE_OF_ASSETS : asiTitle.en.TYPE_OF_ASSETS}</th>
                              <th className="text-center" colSpan="5">{storedLanguage === 'hi' ? asiTitle.hi.GROSS_VALUE : asiTitle.en.GROSS_VALUE}</th>
                              <th className="text-center" colSpan="4">{storedLanguage === 'hi' ? asiTitle.hi.DESCRIPTION : asiTitle.en.DESCRIPTION}</th>
                              <th className="text-center" colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.NET_VALUE : asiTitle.en.NET_VALUE}</th>
                           </tr>
                           <tr>
                              <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.OPENING_AS_ON : asiTitle.en.OPENING_AS_ON}</th>
                              <th className="text-center" colSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.ADDITIONAL_DURING_THE_YEAR : asiTitle.en.ADDITIONAL_DURING_THE_YEAR}</th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.DEDUCTION_DURING_YEAR : asiTitle.en.DEDUCTION_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CLOSING_AS_ON : asiTitle.en.CLOSING_AS_ON }} /></th>
                              <th className="text-center" rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.UP_TO_YEAR_BEGINING : asiTitle.en.UP_TO_YEAR_BEGINING}</th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.PROVIDE_DURING_YEAR : asiTitle.en.PROVIDE_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.SOLD_DISCARD_DURING_YEAR : asiTitle.en.SOLD_DISCARD_DURING_YEAR }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.UP_TO_YEAR_END : asiTitle.en.UP_TO_YEAR_END }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.OPENING_AS_ONS : asiTitle.en.OPENING_AS_ONS }} /></th>
                              <th className="text-center" rowSpan="2"><div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.CLOSING_AS_ONS : asiTitle.en.CLOSING_AS_ONS }} /></th>
                           </tr>
                           <tr>
                              <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.DUE_TO_REVALUATION : asiTitle.en.DUE_TO_REVALUATION}</th>
                              <th className="text-center">{storedLanguage === 'hi' ? asiTitle.hi.ACTUAL_ADDITION : asiTitle.en.ACTUAL_ADDITION}</th>
                           </tr>
                           <tr>
                              <th className="text-center">1</th>
                              <th className="text-center">2</th>
                              <th className="text-center">3</th>
                              <th className="text-center">4</th>
                              <th className="text-center">5</th>
                              <th className="text-center">6</th>
                              <th className="text-center">7</th>
                              <th className="text-center">8</th>
                              <th className="text-center">9</th>
                              <th className="text-center">10</th>
                              <th className="text-center">11</th>
                              <th className="text-center">12</th>
                              <th className="text-center">13</th>
                           </tr>
                        </thead>
                        <tbody>

                          {blockCData.length>0 && blockCData.map((item,i)=>{
                              return (  
                              <tr key={i}>
                              <td>{++srNo}
                                
                              </td>
                              <td key={i} className={i === 7 || i === 9 ? "bold-text" : ""}>{item.ItemName}</td>
                              <td className={itemData[item.assetCode].openingAsOnClass}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`openingAsOn${i}`}
                                 name={`openingAsOn${i}`}
                                 value={itemData[item.assetCode].openingAsOn ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'openingAsOn', e.target.value)}
                                  />
                              </td>
                              <td className={itemData[item.assetCode].dueToRevaluationClass}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`dueToRevaluation${i}`}
                                 name={`dueToRevaluation${i}`}
                                 value={itemData[item.assetCode].dueToRevaluation ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'dueToRevaluation', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].actualAdditionsClass}> 
                                 <input 
                                  type="text" 
                                  className="form-control"
                                  maxLength="18"
                                  id={`actualAdditions${i}`}
                                  name={`actualAdditions${i}`}
                                  value={itemData[item.assetCode].actualAdditions ?? ""}
                                  onChange={e => handleOnChange(item.assetCode, 'actualAdditions', e.target.value)}
                                  />
                              </td>
                              <td className={itemData[item.assetCode].deductionAdjDuringYearClass}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`deductionAdjDuringYear${i}`}
                                 name={`deductionAdjDuringYear${i}`}
                                 value={itemData[item.assetCode].deductionAdjDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'deductionAdjDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].closingAsOn3456Class}>
                                 <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`closingAsOn3456${i}`}
                                 name={`closingAsOn3456${i}`}
                                 value={itemData[item.assetCode].closingAsOn3456 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'closingAsOn3456', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].uptoYearBeginningClass}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                  maxLength="18"
                                 id={`uptoYearBeginning${i}`}
                                 name={`uptoYearBeginning${i}`}
                                 value={itemData[item.assetCode].uptoYearBeginning ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'uptoYearBeginning', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].providedDuringYearClass}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`providedDuringYear${i}`}
                                 name={`providedDuringYear${i}`}
                                 value={itemData[item.assetCode].providedDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'providedDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].adjForSoldDiscardedDuringYearClass}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`adjForSoldDiscardedDuringYear${i}`}
                                 name={`adjForSoldDiscardedDuringYear${i}`}
                                 value={itemData[item.assetCode].adjForSoldDiscardedDuringYear ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'adjForSoldDiscardedDuringYear', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].uptoYearEndClass}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`uptoYearEnd${i}`}
                                 name={`uptoYearEnd${i}`}
                                 value={itemData[item.assetCode].uptoYearEnd ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'uptoYearEnd', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].openingAsOn38Class}> 
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`openingAsOn38${i}`}
                                 name={`openingAsOn38${i}`}
                                 value={itemData[item.assetCode].openingAsOn38 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'openingAsOn38', e.target.value)}
                                 />
                              </td>
                              <td className={itemData[item.assetCode].closingAsOn711Class}>
                              <input 
                                 type="text" 
                                 className="form-control"
                                 maxLength="18"
                                 id={`closingAsOn711${i}`}
                                 name={`closingAsOn711${i}`}
                                 value={itemData[item.assetCode].closingAsOn711 ?? ""}
                                 onChange={e => handleOnChange(item.assetCode, 'closingAsOn711', e.target.value)}
                                 />
                              </td>
                               </tr>
                              )
                          })}
                           
                          
                        </tbody>
                     </table>
                  </div>
               </div>
               
            </div>

            <div className="row">
                <div className="col-12">
                  <hr/>
                </div>
            
                <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                      <button 
                      type="submit" 
                      className="btn btn_orange me-1"
                      onClick={()=>{ window.print()}}
                      >Print 
                      <i className="fa fa-print ms-1"></i>
                      </button>

                      <button 
                      type="button" 
                      className="btn btn_orange me-1"
                      onClick={(e)=>{handleSaveData("SAVE")}}
                      disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}>
                      Save
                     </button>

                      <button 
                      type="reset" 
                      className="btn btn_orange me-1"
                      onClick={handleReset}
                      >
                      Reset
                     </button>

                      <button 
                      type="button" 
                      className="btn btn_orange"
                      onClick={(e)=>( navigate("/dashboard"))}
                      >
                      Cancel
                    </button>

                </div>
              
                <div className="col-lg-4 text-center text-lg-end">
                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
                  >
                  <i className="fa fa-angle-left me-1"></i> 
                  Previous
                 </button>

                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
                  >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
                </button>

                </div>
                        
            </div>

   </div>

  )
}
